<div class="swagger-auth-body">
  <div class="error-container">
    <div class="error-icon">🚫</div>

    <h1 class="error-title">Access Denied</h1>

    <p class="error-message">You do not have sufficient permissions to access the Swagger documentation.</p>

    <div class="error-details">
      <h3>Required Permissions:</h3>
      <ul>
        <li>You must be authenticated with valid credentials</li>
        <li>Your account must have appropriate role assigned</li>
        <li>Additional permissions may be required for API documentation</li>
      </ul>
    </div>

    <div class="action-buttons">
      <button (click)="loginWithDifferentAccount()" class="btn btn-primary" type="button">
        Login with Different Account
      </button>
      <button (click)="goBack()" class="btn btn-secondary" type="button">Go Back</button>
    </div>
  </div>

  <div class="footer">
    <p>&copy; {{ getCurrentYear() }} {{ companyName }}. All rights reserved.</p>
    <p>If you believe this is an error, please contact your system administrator.</p>
  </div>
</div>
